import { ObjectValues } from 'types';

export type ListenEvents = ObjectValues<typeof LISTEN_EVENTS>;
export const LISTEN_EVENTS = {
  LOCATION_UPDATE: 'tracker-location-update',
  VEHICLE_UPDATE: 'vehicle-update',
};
